/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./divider.widget";
var styles_DividerWidget = [];
var RenderType_DividerWidget = i0.ɵcrt({ encapsulation: 2, styles: styles_DividerWidget, data: {} });
export { RenderType_DividerWidget as RenderType_DividerWidget };
export function View_DividerWidget_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["class", "widget widget-divider"]], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_DividerWidget_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "sp-divider-widget", [], null, null, null, View_DividerWidget_0, RenderType_DividerWidget)), i0.ɵdid(1, 4243456, null, 0, i1.DividerWidget, [], null, null)], null, null); }
var DividerWidgetNgFactory = i0.ɵccf("sp-divider-widget", i1.DividerWidget, View_DividerWidget_Host_0, {}, {}, []);
export { DividerWidgetNgFactory as DividerWidgetNgFactory };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/divider.widget.ngfactory.js.pre-build-optimizer.js